<template>
  <article
    data-qa="specialization_item"
    class="specialization-item rounded-20 d-flex flex-column justify-space-between ga-1 text-break"
    :class="{
      'specialization-item--primary': isPrimary,
    }"
  >
    <div class="d-flex flex-column ga-2">
      <h3
        data-qa="specialization_item_name"
        class="text-h6"
      >
        {{ specialization.speciality.name }}
      </h3>
      <p
        data-qa="specialization_item_description"
        class="text-body-2"
      >
        {{ specialization.description }}
      </p>
    </div>

    <div class="d-flex align-end justify-space-between">
      <v-btn
        depressed
        data-qa="specialization_item_btn"
        class="branding-btn rounded-20 px-4 align-self-end"
        height="52"
        :href="getSpecializationHref(specialization.speciality.id)"
        :class="isPrimary
          ? 'branding-btn--white'
          : 'branding-btn--primary'"
      >
        {{ textBtn }}
      </v-btn>
      <div
        class="specialization-item__image-container"
      >
        <MaskIcon
          v-if="specialization.speciality.icon?.url"
          class="specialization-item__image"
          :src="specialization.speciality.icon.url"
          :size="150"
        />
      </div>
    </div>
  </article>
</template>

<script setup lang="ts">
import type { LpuBrandingSpecialization } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_types'
import MaskIcon from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/MaskIcon.vue'

const props = defineProps<{
  isPrimary: boolean
  lpuDoctorsUrl: string
  specialization: LpuBrandingSpecialization
  textBtn: string
}>()

function getSpecializationHref(specialityId: number) {
  const url = new URL(props.lpuDoctorsUrl)

  url.hash = `speciality=${specialityId}`

  return url.href
}
</script>

<style scoped lang="scss">
@import '~www/themes/doctors/common/variables';

.specialization-item {
  padding: 24px;
  color: var(--lpu-branding-color-text);
  background-color: var(--lpu-branding-color-background);
  justify-content: flex-start;
  flex-shrink: 0;
  overflow: hidden;
  hyphens: auto;

  &__image-container {
    position: relative;
    width: 98px;
    height: 107px;
    pointer-events: none;
    margin-left: 2px;
    margin-right: 28px;
  }

  &__image {
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0.15;
    color: var(--lpu-branding-color-primary);
  }

  &--primary {
    color: $ui-kit-bg-gray-0;
    background-color: var(--lpu-branding-color-primary);
  }

  &--primary &__image {
    color: $ui-kit-bg-gray-0;
    opacity: 0.5;
  }
}
</style>
